var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\xC9l\\xE9ments",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icones/Home/Full/Gris",
    className: "st0-fill",
    fill: "#92999C"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7073,12.2932 L17.7073,9.2932 L12.7073,4.2932 C12.3163,3.9022 11.6843,3.9022 11.2933,4.2932 L6.2933,9.2932 L3.2933,12.2932 C2.9023,12.6842 2.9023,13.3162 3.2933,13.7072 C3.6843,14.0982 4.3163,14.0982 4.7073,13.7072 L6.0003,12.4142 L6.0003,19.0002 C6.0003,19.5522 6.4473,20.0002 7.0003,20.0002 L17.0003,20.0002 C17.5533,20.0002 18.0003,19.5522 18.0003,19.0002 L18.0003,12.4142 L19.2933,13.7072 C19.4883,13.9022 19.7443,14.0002 20.0003,14.0002 C20.2563,14.0002 20.5123,13.9022 20.7073,13.7072 C21.0983,13.3162 21.0983,12.6842 20.7073,12.2932",
    id: "Fill-1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeGrey);
export default __webpack_public_path__ + "static/media/home-grey.bb9dddab70bdf126884c04e3033910b4.svg";
export { ForwardRef as ReactComponent };